import { BreachPathDetailsBaseDataProvider } from './BreachPathDetailsBaseDataProvider';
import { BreachPathDetailsWebComponentSchema } from '../types';

export class BreachPathDetailsGZDataProvider extends BreachPathDetailsBaseDataProvider {
}
